import { z } from 'zod';
import { finishReasons, usageSchema } from './generation.js';
export const errorCodes = [
    'unauthorized', 'forbidden', 'invalid_request', 'model_unavailable',
    'identity_mismatch', 'context_limit', 'capacity_exceeded', 'rate_limit',
    'timeout', 'upstream_error', 'refusal', 'incomplete_response',
    'invalid_json', 'schema_failure', 'network_error', 'invalid_response',
];
// Enough to see how an answer went wrong (e.g. a whitespace loop or a repeated phrase).
export const partialOutputChars = 2_000;
export function partialOutput(text) {
    return { text: text.slice(0, partialOutputChars), length: text.length };
}
export const errorResponseSchema = z.strictObject({
    requestId: z.string().optional(),
    usage: usageSchema.nullable().optional(),
    // Set when the model stopped early, e.g. at its output cap.
    finishReason: z.enum(finishReasons).optional(),
    // An unfinished answer's start, returned only to the caller that sent the prompt.
    partialOutput: z.strictObject({
        text: z.string().max(partialOutputChars),
        length: z.number().int().nonnegative(),
    }).optional(),
    error: z.strictObject({
        code: z.enum(errorCodes),
        message: z.string(),
    }),
});
export class AIError extends Error {
    code;
    status;
    requestId;
    retryAfter;
    usage;
    finishReason;
    partialOutput;
    constructor(message, code, status, requestId, retryAfter) {
        super(message);
        this.code = code;
        this.status = status;
        this.requestId = requestId;
        this.retryAfter = retryAfter;
        this.name = 'AIError';
    }
}
